var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{staticClass:"home-old__preview-carousel"},[_c('preview-carousel')],1),_vm._v(" "),_c('div',{staticClass:"home-old__markets"},[_c('page-markets',{attrs:{"headerId":0,"embedded":true},on:{"embeddedInitialLoadStateChange":_vm.onEmbeddedInitialLoadStateChange}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41ca103a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/home-old/home-old.vue
// module id = nJds
// module chunks = 0